export default __webpack_public_path__ + "static/media/category.6c8f7569.svg";